<template>
  <b-container class="my-4">
    <b-row class="text-center mb-4" align-h="center" v-if="loading">
      <b-col cols="1">
        <i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card v-if="!loading">
          <b-container>
            <b-row>
              <b-col sm="12" md="8">
                <p>
                  <b-link class="mr-4" :to="{ name: 'Controls' }">all controls</b-link>
                  <b-button class="mr-4" v-if="permission.edit" variant="outline-primary" :to="{ name: 'FormEdit', params: { id: item.id, model: 'control' }}">Edit</b-button>
                  <delete-standard
                    v-if="permission.delete"
                    :id="item.id"
                    model="control"
                  ></delete-standard>
                </p>
                <h2>
                  {{item.name}} [{{item.id}}]
                </h2>
                <div class="mb-2" style="font-size: 1.2em; font-weight: 500">
                  {{item.objective}}
                </div>
                <div v-html="item.description"></div>
              </b-col>
              <b-col>
                <h4>Status</h4>
                <div style="font-size: 1.2em">
                  {{item.controlstatus.name}}
                </div>
                <h4 class="mt-5">Themes</h4>
                <div v-for="theme in item.controlthemes" :key="'theme' + theme.id" style="font-size: 1.2em">
                  {{theme.name}}
                </div>
                <h4 class="mt-5">Risks</h4>
                <div v-for="risk in item.controlrisks" :key="'risk' + risk.id" style="font-size: 1.2em">
                  {{risk.name}}
                </div>
                <h4 class="mt-5">Functions</h4>
                <div v-for="area in item.areas" :key="'area' + area.id" style="font-size: 1.2em">
                  {{area.name}}
                </div>
                <h4 class="mt-5">Projects</h4>
                <div v-for="project in item.projects" :key="'project' + project.id" style="font-size: 1.2em">
                  {{project.name}}
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h4 class="mt-5">Obligations</h4>
                <div v-for="obligation in item.obligations" :key="'obligation' + obligation.id" class="mb-3">
                  <div><i>{{obligation.regulation.name_short}}</i></div>
                  <div><strong><b-link class="mr-4" :to="{ name: 'RegDecompObligation', params: { id: obligation.id }}">{{obligation.name}}</b-link></strong></div>
                  <div>{{obligation.description}}</div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ac from '@/libs/accesscontrol'
import DeleteStandard from '@/components/DeleteStandard'

export default {
  name: 'Control',
  components: {
    DeleteStandard
  },
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: function () {
    this.$stat.log({ page: 'control', action: 'open control', model: 'control', model_id: this.$route.params.id })
    this.permission.delete = ac.can(this.user.acgroups).deleteAny('control').granted
    this.permission.edit = ac.can(this.user.acgroups).updateAny('control').granted
    this.load()
  },
  data () {
    return {
      loading: true,
      item: null,
      permission: {
        delete: false,
        edit: false
      }
    }
  },
  methods: {
    load: async function () {
      this.loading = true
      try {
        const apiName = 'cosmos'
        const path = `/controls/control/${this.$route.params.id}`
        this.item = await this.$Amplify.API.get(apiName, path)
        this.loading = false
      } catch (e) {
        this.$logger.warn(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
